import React, { useEffect } from 'react';
import { ATMDropdown, ATMField, ATMForm, ATMGrid } from 'shared-it-appmod-ui';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { useTailNumberContext } from 'src/contexts/tail-number.context';
import Lang from 'src/libraries/language';
import {
  OperatorTailFormSchema,
  IOperatorTailForm,
} from 'src/models/operator-tail.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: Partial<IOperatorTailForm>;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const OperatorTailsForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  const {
    state: flightOperatorState,
    actions: flightOperatorAction,
  } = useFlightOperatorContext();
  const {
    state: tailNumberState,
    actions: tailNumberAction,
  } = useTailNumberContext();

  useEffect(() => {
    flightOperatorAction.listGET();
    tailNumberAction.listGET();
  }, [flightOperatorAction, tailNumberAction]);

  const operators = flightOperatorState.list.map((value) => {
    return {
      key: value.operatorId,
      text: value.name,
      value: value.operatorId,
    };
  });

  const tailNumbers = tailNumberState.list.map((value) => {
    return {
      key: value.tailId,
      text: value.tailNumber,
      value: value.tailId,
    };
  });

  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={OperatorTailFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="equal">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_OPERATOR_NAME}
                    name="operatorId"
                    control={control}
                    as={ATMDropdown}
                    placeholder={Lang.LBL_SELECT}
                    onChange={([_, { value }]) => value}
                    options={operators}
                    clearable
                    required
                    search
                    selection
                    fluid
                    error={errors.operatorId}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_TAIL_NUMBER}
                    name="tailId"
                    control={control}
                    as={ATMDropdown}
                    placeholder={Lang.LBL_SELECT}
                    onChange={([_, { value }]) => value}
                    options={tailNumbers}
                    clearable
                    required
                    search
                    selection
                    fluid
                    error={errors.tailId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default OperatorTailsForm;
